module.exports = __webpack_public_path__ + "img/wncs.5d9a60c.png";